import { render } from "./OnboardingTour.vue?vue&type=template&id=d854fc4e&scoped=true"
import script from "./OnboardingTour.vue?vue&type=script&lang=js"
export * from "./OnboardingTour.vue?vue&type=script&lang=js"

import "./OnboardingTour.vue?vue&type=style&index=0&id=d854fc4e&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d854fc4e"]])

export default __exports__